import { html, View } from 'rune-ts';

/**
 * 보너스 발동 순간 1회성 화면 전체 amber radial flash.
 * pointer-events-none이라 클릭 차단 안 함.
 * GamePage가 bonusActive false → true 전이 감지 시 마운트.
 *
 * key prop은 매 발동마다 다르게 줘서 element가 새로 마운트되며 animation 재실행되도록 함.
 */
export type BonusFlashData = {
  flashKey: number;
};

export class BonusFlashView extends View<BonusFlashData> {
  override template() {
    return html`
      <div
        data-flash-key="${this.data.flashKey}"
        class="bonus-flash fixed inset-0 z-30 pointer-events-none"
      ></div>
    `;
  }
}
